import cx from "clsx"
import { getStageColor } from "../../../utils/stageColors.js"
import styles from "./index.module.less"
import { localisedValue } from "utils/index.js"

const StatusTag = ({ data, children, className, style, ...rest }) => {
  return (
    data && (
      <div
        className={cx(className, styles.status)}
        style={{
          "--status-bg-color": data?.color || getStageColor(data?.key),
          ...(data?.textColor && { "--text-color": data?.textColor }),
          ...style,
        }}
        {...rest}
      >
        {children ||
          localisedValue({ object: data, key: "title" }) ||
          localisedValue({ object: data, key: "name" })}
      </div>
    )
  )
}

export default StatusTag
